Ext.define('SA.DefaultLimitCheck', {
    constructor(values) {
        this.checks = values.map(value => new SA.DefaultDatasetLimit(value));
    },

    canExport() {
        return !this.isBeyondLimit();
    },

    canHideWindow() {
        return !this.popup || !!this.popup.isDestroyed;
    },

    isBeyondLimit() {
        return this.checks.some(check => check.isBeyondLimit());
    },

    maybeGetMessage() {
        if (this.isBeyondLimit()) {
            let listeners = {'click:link': this.showPopup, scope: this},
                beyondPerWeekLimit = this.checks.some(check => check.isBeyondPerWeekLimit()),
                beyondPerYearLimit = this.checks.some(check => check.isBeyondPerYearLimit()),
                data = {beyondPerWeekLimit, beyondPerYearLimit};

            return {xtype: 'beyond-limit-default-message', listeners, data};
        }

        return null;
    },

    showPopup() {
        var tplData = this.checks.filter(check => check.isBeyondLimit()).map(check => check.serialize());

        this.popup = Ext.widget({xtype: 'beyond-limit-popup', data: tplData});
    }
});